<aside class="notification-bar" [class.collapsed]="!isNotificationBarCollapsed">
  <div class="notification-bar-header" [class.hasNewNotifications]="unreadCount > 0">
    <ion-button fill="clear" class="back-btn" (click)="closeNotificationBar()">
      <ion-icon name="chevron-back-outline"></ion-icon>
    </ion-button>
    <h3 class="notification-bar-title">Notifications</h3>
    <!-- <ion-button fill="clear" class="close-btn" (click)="closeNotificationBar()">
      <ion-icon name="close-outline"></ion-icon>
    </ion-button> -->
    <span class="unread-count" *ngIf="unreadCount > 0">{{unreadCount}} New</span>
    <app-primary-button *ngIf="unreadCount > 0" [label]="'Mark all read'" customClass="notificationBtn"
      (click)="markAllAsRead()">
    </app-primary-button>
  </div>
  <div class="notification-bar-content notification-content-wrapper">
    <!-- <p class="no-notifications-text">You have no new notifications.</p> -->
    <app-no-data *ngIf="notificationsList.length === 0" message="You have no new notifications."></app-no-data>
    <div class="notificationsListWrapper">
      <div class="notificationListItem" *ngFor="let notification of notificationsList | slice:0:5"
        (click)="openNotification(notification)">
        <!-- <ion-icon [name]="notification.icon" alt="Notification Icon" class="notificationIcon"></ion-icon> -->
        <div class="notificationContent">
          <h4 class="notificationTitle ">
            <span class="line-clamp line-clamp-2">
              {{notification.title}}
            </span>
            <span *ngIf="!notification.read" class="notification-dot"></span>
          </h4>
          <p class="notificationDesc line-clamp line-clamp-3">
            {{notification.body}}
          </p>
          <span class="notificationTime">{{getRelativeTime(notification.date)}}</span>
        </div>
      </div>

      <app-primary-button [iconOrder]="'right'" [ionIconName]="'arrow-forward-outline'" (click)="viewAllNotifications()"
        [label]="'View all Notifications'" customClass="fadedBtn">
      </app-primary-button>
    </div>
  </div>
</aside>